export default "__VITE_ASSET__768b5fbe__$_?component__"